import React, { useEffect, useState } from "react";
import { vendorServices } from "../../services/vendorServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

function VendorDashboard() {
    const [isLoading, setIsLoading] = useState(false);
    const [alertComponent, setAlertComponent] = useState({
        open: false,
        message: "",
        type: "",
    });
    let navigate = useNavigate();

    const handleClose = (event, reason) => {
        setAlertComponent({ ...alertComponent, open: false });
    };

    useEffect(() => {
        vendorServices.getVendorDetails()
            .then(function (response) {
                if (response?.data?.success == true) {
                    if (response?.data?.data?.vendor.isOnboarded == false) {
                        let path = `/admin/welcome`;
                        navigate(path);
                    }
                }
                // openAlert(
                // true,
                // "success",
                // `Magic link sent successfully on your registered E-mail id.`
                // );
                // navigateToLogin("/auth/login", 2000);
            })
            .catch(function (error) {
                // setAlertComponent({
                // open: true,
                // type: "error",
                // message: `${error?.response?.data?.message}`,
                // });
            })
            .finally((param) => {
                setIsLoading(false);
            });
    }, []);

    // const openAlert = (open, type, message) => {
    //     setAlertComponent({ open, type, message });
    // };

    return (
        <div class="login-form">
            <div class="text-center">
                <h3 class="title">Vendor Dashboard</h3>
                <p>
                    Enter your username or email for verification process we will send 4
                    digit code to your email.
                </p>
            </div>

            <AlertComponent
                alertComponent={alertComponent}
                handleClose={handleClose}
            />
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default VendorDashboard;
